<template>
    <div class="landing">
        <section class="welcome" @click="qr_gplay = false, qr_ios = false" :style="{backgroundImage: 'url(' + images.welcome + ')'}">
            <video-background
                preload
                :poster="images.welcome"
                :src="require('@/assets/videos/landosish.mp4')"
                style="height: 100vh; width: 100%; position: absolute;"
            >
                <!-- :src="require('@/assets/videos/welcome.mp4')" -->
            </video-background>
            <div class="mobile-apps" v-if="!webViewMode && !AppValidating">
                <div class="mobile-app" @click.stop>
                    <a href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank" class="mobile-app__link"></a>
                    <div class="mobile-app__open" @click="qr_gplay = true, qr_ios = false"></div>
                    <div class="mobile-app-popup" v-if="qr_gplay">
                        <div class="mobile-qr">
                            <img src="@/assets/images/welcome/qr-gplay.webp" alt="qr wildwood gplay" width="200px">
                        </div>
                        <a class="mobile-app__gplay" href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank">Ссылка на приложение</a>
                    </div>
                    <img src="@/assets/images/welcome/gplay.svg" width="24px">
                    <p>GPlay</p>
                </div>
                <div class="mobile-app" @click.stop>
                    <a href="https://play.google.com/store/apps/details?id=com.wildwoodonline" target="_blank" class="mobile-app__link"></a>
                    <div class="mobile-app__open" @click="qr_ios = true, qr_gplay = false"></div>
                    <div class="mobile-app-popup" v-if="qr_ios">
                        <div class="mobile-qr">
                            <img src="@/assets/images/welcome/qr-ios.webp" alt="qr wildwood gplay" width="200px">
                        </div>
                        <a class="mobile-app__gplay" href="https://apps.apple.com/us/app/wildwood-%D1%81%D0%BF%D0%BE%D1%80%D1%82%D0%B8%D0%B2%D0%BD%D0%BE%D0%B5-%D1%81%D0%BE%D0%BE%D0%B1%D1%89%D0%B5%D1%81%D1%82%D0%B2%D0%BE/id1604410665" target="_blank">Ссылка на приложение</a>
                    </div>
                    <img src="@/assets/images/welcome/ios.svg" width="128px">
                </div>
            </div>
            <div class="welcome-user" v-if="profile && profile.avatar">
                <p class="welcome-user__name">{{ profile.firstname }}</p>
                <div class="welcome-user__avatar" :style="{backgroundImage: 'url(' + profile.avatar + ')'}"></div>
            </div>
            <div class="wrap">
                <!-- <div class="welcome__logo">
                    <img src="@/assets/images/mini-logo.png" width="60px" alt="wildwood лого" />
                </div> -->
                <h1 class="welcome__title">Добро пожаловать <br>в <span>WildWood</span></h1>
                <p class="welcome__text">Сервис и сообщество экстремальных тусовок</p>
                <router-link :to="{name:'registration'}" class="button" v-if="!profile">Присоединиться</router-link>    
                <router-link :to="{name:'events'}" class="button" v-else>Перейти к ивентам</router-link>    
            </div>
            <div class="welcome-scroll">
                <!-- <img src="@/assets/images/welcome/eye.svg" width="45px"> -->
                <img src="@/assets/images/welcome/down.svg" width="18px">
            </div>
            
        </section>
        <section class="section">
            <div class="wrap">
                <div class="section-content">
                    <!-- <h2>Найди компанию для спорта</h2> -->
                    <!-- <h2>Смотри на карте, кто катается в твоём городе</h2> -->
                    <h2>Теперь не придется кататься в одиночестве</h2>
                    <p>Смотри, кто катается на карте ивентов. На карте WildWood можно найти множество компаний, катающиеся в твоём городе.</p>
                    <router-link :to="{name: 'events'}" class="button desc">Найти компанию</router-link>
                </div>
                <div class="section-image">
                    <div class="section-image__container" :style="{backgroundImage: 'url(' + images.find + ')'}">
                        <img class="left-bottom" src="@/assets/images/welcome/find-two.webp" alt="wildwood мероприятие">
                    </div>
                    <router-link :to="{name: 'events'}" class="button">Карта ивентов</router-link>
                </div>
            </div>
        </section>
        <section class="section reverse">
            <div class="wrap">
                <div class="section-image">
                    <div class="section-image__container" :style="{backgroundImage: 'url(' + images.create + ')'}">
                        <!-- <img class="right-bottom" src="@/assets/images/welcome/create-two.png" alt=""> -->
                    </div>
                    <router-link :to="{name: 'events'}" class="button">Найти компанию</router-link>
                </div>
                <div class="section-content">
                    <h2>Создавай события и приглашай друзей</h2>
                    <p>Создай свою тусовку с блэкджеком и с кем пожелаешь. Выбери параметры события, приглашай людей и заводи новых друзей.</p>
                    <router-link :to="{name: 'events'}" class="button desc">Собрать тусовку</router-link>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="wrap">
                <div class="section-content">
                    <h2>Находи места для катания</h2>
                    <p>На карте мест, можно узнать множество спортивных спотов. Будь то скейт-парк, место для бейсджампинга, снежный склон, или высота для бейсджампинга.</p>
                    <router-link :to="{name: 'places'}" class="button desc">Смотреть места</router-link>
                </div>
                <div class="section-image">
                    <div class="section-image__container" :style="{backgroundImage: 'url(' + images.place + ')'}">
                        <!-- <img class="right-bottom" src="@/assets/images/welcome/create-two.png" alt=""> -->
                    </div>
                    <router-link :to="{name: 'places'}" class="button">Смотреть места</router-link>
                </div>
            </div>
        </section>
        <section class="section reverse">
            <div class="wrap">
                <div class="section-image">
                    <div class="section-image__container" :style="{backgroundImage: 'url(' + images.blog + ')'}">
                        <!-- <img class="right-bottom" src="@/assets/images/welcome/create-two.png" alt=""> -->
                    </div>
                    <router-link :to="{name: 'lenta'}" class="button">На ленту</router-link>
                </div>
                <div class="section-content">
                    <h2>Пости крутой контент, и набирай популярность</h2>
                    <p>Знаешь, как постить крутой контент? В ленте WildWood для тебя есть уютный профиль для публикации твоих идей.</p>
                    <router-link :to="{name: 'lenta'}" class="button desc">На ленту</router-link>
                </div>
            </div>
        </section>
        <footer class="welcome-footer">
            <div class="wrap">
                <!-- <div class="section-sports">
                    <p class="welcome-footer-text">В целом цель сервиса WildWood - объединить людей, в одно онлайн сообщество, которое решит популярные проблемы, с которыми сталкивается человек, интересующийся экстремальными видами спорта. </p>
                </div> -->
                <Sports v-if="sports" :sports="sports" :type="'all'" />
                <div class="welcome-footer-bottom">
                    <div class="welcome-socials">
                        <a href="https://vk.com/wildwoodteam" target="_blank" class="welcome-socials__item">
                            <img src="@/assets/images/welcome/socials/vk.svg">
                        </a>
                        <a href="https://www.instagram.com/wildwoodteam" target="_blank" class="welcome-socials__item">
                            <img src="@/assets/images/welcome/socials/instagram.svg">
                        </a>
                        <a href="https://www.facebook.com/wildwoodteam" target="_blank" class="welcome-socials__item">
                            <img src="@/assets/images/welcome/socials/facebook.svg">
                        </a>
                    </div>
                    <p class="copyright">©copyright by wildwood 2021</p>
                </div>
            </div>
        </footer>
        
        
    </div>
    
</template>
<script>
import Sports from '@/components/Filters/Sports.vue'
import VideoBackground from 'vue-responsive-video-background-player'
export default {
    name: 'Welcome',
    data: () => {
        return {
            // profile: null,
            images: {
                welcome: require('@/assets/images/welcome/welcome.webp'),
                find: require('@/assets/images/welcome/find.webp'),
                create: require('@/assets/images/welcome/create.webp'),
                place: require('@/assets/images/welcome/place.webp'),
                blog: require('@/assets/images/welcome/blog.webp')
            },
            qr_gplay: false,
            qr_ios: false,
            sports: null
        }
    },
    computed: {
        webViewMode() {
            return this.$store.getters.webViewMode
        },
        profile() {
            return this.$store.getters.getAuthUser
        },
        AppValidating() {
            return this.$store.getters.AppValidating
        }
    },
    components: {
        VideoBackground,
        Sports,
    },
    methods: {
        async fetchSports () {
            this.sports = await this.$store.dispatch('fetchSports');
        },
        indentificateUser() {
            let profile = JSON.parse(localStorage.getItem('user'));
            profile 
                ? this.$store.dispatch('setAuthUser', profile)
                : '';
            this.$store.dispatch('notifications', { user: profile.id })
        },
    },
    async created () {
        this.indentificateUser()
        this.fetchSports()
        let referrer = document.referrer;
        this.$axios.get('https://ipinfo.io?token=03c7795c46fbad').then(resp => {
            let data = resp.data ? {
                ip: resp.data.ip, 
                country: resp.data.country, 
                city: resp.data.city,
                page: this.$route.name,
                referrer} : '';
            this.$axios.post('/api/guest', data)
        })
        document.title = this.$route.meta.title;
    }
}
</script>
<style lang="stylus">
.landing
    flex-direction column
    
    .section
        padding 120px 0
        +to-width(900px)
            padding 40px 0
        &:first-child
            +to-width(900px)
                padding-top 80px

        &:last-child
            +to-width(900px)
                padding-bottom 80px


        .wrap
            display flex
            align-items center
            +to-width(900px)
                flex-direction column
        &.reverse
            .wrap
                +to-width(900px)
                    flex-direction column-reverse


        &-content
            padding 0 30px
            +to-width(540px)
                padding 0
            h2
                font-size 42px
                line-height 50px
                font-weight 700
                padding-bottom 46px
                +to-width(1350px)
                    font-size 32px
                    line-height 42px
                    padding-bottom 25px
                +to-width(540px)
                    font-size 28px
            p
                font-size 18px
                line-height 34px
                font-weight 400
                +to-width(540px)
                    font-size 16px
            
        .button
            margin-top 30px
            font-size 18px
            background-color #FD9D80
            padding 15px 25px
            border-radius 15px
            color white
            border 2px solid #FD9D80
            display none
            +to-width(900px)
                display inline-block
                margin-left auto
                margin-right auto
            &.desc
                display inline-block
                +to-width(900px)
                    display none
            &:hover
                background-color transparent
                color #FD9D80
        
        &-image
            padding 0 30px
            +to-width(900px)
                width 100%
                margin-top 40px
            +to-width(540px)
                padding 0
            
            &__container
                width 650px
                height 430px
                background-size cover 
                background-position center
                border-radius 20px
                position relative
                +to-width(1350px)
                    width 550px
                    height 400px
                +to-width(1060px)
                    width 400px
                    height 350px
                +to-width(900px)
                    width 100%
                    max-width 650px
                    height 350px
                
                img
                    +to-width(1350px)
                        max-width 350px
                    &.left-bottom
                        left -40px
                        bottom -20px
                        position absolute
                        +to-width(540px)
                            left 0
                            max-width 70%
                    &.right-bottom
                        right -60px
                        bottom -80px
                        position absolute
    .welcome
        display flex
        align-items center
        justify-content center
        width 100%
        height 100vh
        background-size cover
        background-position center
        position relative
        color white
        overflow hidden
        position relative
        +to-width(900px)
            margin-bottom 40px
        

        &-scroll
            position absolute
            bottom 30px
            display flex
            flex-direction column
            align-items center
            z-index 2
            img
                animation up-down 1s infinite
        
        &:after
            content ''
            position absolute
            left 0
            top 0
            right 0
            bottom 0
            background-color rgba(0,0,0,0.3)
        
        // video
        //     min-width 100%
        //     min-height 100%
        //     left 0
        //     top 0
        //     position absolute
        
        &-user
            position absolute
            right 25px
            top 25px
            z-index 3
            display flex
            align-items center
            +to-width(640px)
                top 55px
            +to-width(410px)
                display none

            &__name
                margin-right 10px
                font-size 14px
                font-weight 500

            &__avatar
                width 40px
                height 40px
                border-radius 50%
                border 2px solid white
                background-size cover
        
        .wrap
            z-index 2
            display flex
            flex-direction column
            align-items center
            +to-width(640px)
                align-items flex-start
                padding 0 30px
            +to-width(420px)
                align-items center

        &__logo
            margin-bottom 20px
            padding 20px
            border-radius 50%
            background-color white
            // background-color #2d2c3a

        &__title
            text-align center
            font-size 52px
            font-weight 700
            line-height 68px
            padding-bottom 10px
            +to-width(640px)
                font-size 42px
                text-align left
            +to-width(540px)
                font-size 36px
                line-height 54px
            +to-width(420px)
                text-align center
                font-size 28px
                line-height 42px

        &__text
            color white
            font-size 24px
            text-align center
            line-height 36px
            +to-width(640px)
                font-size 22px
                line-height 30px
                text-align left
            +to-width(540px)
                font-size 18px
                line-height 26px
            +to-width(420px)
                text-align center
        
        .button
            border none
            margin 0 auto
            margin-top 30px
            display flex
            font-weight 600
            font-size 16px
            border-radius 18px
            padding 15px 25px
            +to-width(640px)
                margin 0
                margin-top 30px
        
        &-socials
            display flex
            margin-bottom 20px

            &__item
                margin 5px
                img
                    width 40px
                    height 40px

        &-footer
            padding 40px 0
            background-color #f0f0f0
            +to-width(900px)
                margin-top 40px
            
            .sports
                justify-content center
                
            .sport
                font-size 14px
                font-weight 500


            &-text
                font-size 18px
                line-height 30px
                text-align center
                color black
                padding 50px 0
                padding-bottom 40px

            &-bottom
                display flex
                align-items center
                flex-direction column
                margin-top 20px

@keyframes up-down {
    0% {
        transform: translateY(0)
    }
    50% {
        transform: translateY(7px)
    }
    100% {
        transform: translateY(0)
    }
}

</style>